import * as angular from 'angular';
import template from "./equipment-box.directive.tpl.html";

export default angular
  .module('aps.directives.equipmentBox', [])
  .directive('equipmentBox', () => {
    return {
      replace: true,
      scope: {
        equipment: '=',
        options: '=',
        losspercentclass: '@',
        borderclass: '@',
      },
      template: template,
    };
  })
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/equipment-box.directive.ts